<template>
    <div class="container">
        <div style="font-size: 8em; text-align: center;" clas="ds-div-head">😢
            <span style="font-weight: bold;">{{error.title}}</span>
        </div>
        <div style="text-align: center;">
            <p style="font-size: 4em;">¡Lo sentimos!</p>
            <h2>{{ error.message }}</h2>
            <router-link class="btn btn-primary" :to="'/'">
                Ir a la página principal
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        error: {
            type: Object,
            default: () => {}
        }
    }
}
</script>